












import LayoutSimple from "@/layouts/LayoutSimple.vue";
import { Component, Vue } from "vue-property-decorator";
import ErrorCard from "../../components/utility/ErrorCard.vue";

@Component({
  components: {
    LayoutSimple,
    ErrorCard
  }
})
export default class PortalErrorPage extends Vue {
  items = [
    {
      text: "Website",
      disabled: false,
      href: "https://www.mmmint.ai"
    },
    {
      text: "Impressum",
      disabled: false,
      href: "https://www.mmmint.ai/impressum/"
    },
    {
      text: "AGB",
      disabled: false,
      href: "https://www.mmmint.ai/agbs/"
    }
  ];

  loading = false;

  async reload() {
    try {
      this.loading = true;
      this.$router.push({ name: "PartnerHome" });
    } catch (error) {
      this.$log.error(error);
      this.$router.push({ name: "PartnerError" });
    } finally {
      this.loading = false;
    }
  }
}
